import { Controller, type Control } from "react-hook-form";
import MenuDropdown from "@/components/MenuDropdown";
import type { CreateTestPersonFormValues, DropdownOption } from "./types";

type ProgramSectionProps = {
  control: Control<CreateTestPersonFormValues>;
  options: DropdownOption[];
  noneOption: DropdownOption;
  disabled?: boolean;
  onProgramSelect: (value: string) => void;
};

export default function ProgramSection({
  control,
  options,
  noneOption,
  disabled,
  onProgramSelect
}: ProgramSectionProps) {
  return (
    <div data-testid="create-test-person-program-section">
      <div className="text-title-medium mb-4">Program</div>
      <Controller
        control={control}
        name="programType"
        rules={{
          validate: (value, formValues) =>
            !value || Boolean(formValues.sectionId) || "Section is required when program is set"
        }}
        render={({ field }) => (
          <MenuDropdown
            label="Program"
            options={options}
            value={options.find((option) => option.value === field.value) ?? noneOption}
            onSelect={(option) => {
              field.onChange(option.value);
              onProgramSelect(option.value);
            }}
            getLabel={(option) => option.label}
            renderItem={(option) => option.label}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
}
